import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";

@Component({
  selector: "app-info-panel",
  templateUrl: "./info-panel.component.html",
  styleUrls: ["./info-panel.component.scss"],
  imports: [CommonModule],
  standalone: true,
})
export class InfoPanelComponent {
  @Input() title: string = "";
  @Input() text: string = "";
}
